import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _df461dda = () => interopDefault(import('../pages/achievement/index.vue' /* webpackChunkName: "pages/achievement/index" */))
const _4ce9824b = () => interopDefault(import('../pages/advertise/index.vue' /* webpackChunkName: "pages/advertise/index" */))
const _73a4ec6e = () => interopDefault(import('../pages/agreement/index.vue' /* webpackChunkName: "pages/agreement/index" */))
const _5a1ed020 = () => interopDefault(import('../pages/calendar/index.vue' /* webpackChunkName: "pages/calendar/index" */))
const _1b6456e0 = () => interopDefault(import('../pages/customer/index.vue' /* webpackChunkName: "pages/customer/index" */))
const _3ee104e6 = () => interopDefault(import('../pages/details/index.vue' /* webpackChunkName: "pages/details/index" */))
const _84a3c1b8 = () => interopDefault(import('../pages/goals/index.vue' /* webpackChunkName: "pages/goals/index" */))
const _4ce6deff = () => interopDefault(import('../pages/maisoku/index.vue' /* webpackChunkName: "pages/maisoku/index" */))
const _42884e48 = () => interopDefault(import('../pages/media/index.vue' /* webpackChunkName: "pages/media/index" */))
const _e5bc3a2e = () => interopDefault(import('../pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _405c7cfd = () => interopDefault(import('../pages/project/index.vue' /* webpackChunkName: "pages/project/index" */))
const _6128ed9a = () => interopDefault(import('../pages/response/index.vue' /* webpackChunkName: "pages/response/index" */))
const _15668939 = () => interopDefault(import('../pages/sale/index.vue' /* webpackChunkName: "pages/sale/index" */))
const _056b6990 = () => interopDefault(import('../pages/achievement/output.vue' /* webpackChunkName: "pages/achievement/output" */))
const _1be8a808 = () => interopDefault(import('../pages/achievement/registration.vue' /* webpackChunkName: "pages/achievement/registration" */))
const _3e98c01a = () => interopDefault(import('../pages/advertise/analysis.vue' /* webpackChunkName: "pages/advertise/analysis" */))
const _4d8a93cc = () => interopDefault(import('../pages/advertise/management.vue' /* webpackChunkName: "pages/advertise/management" */))
const _a4ee7060 = () => interopDefault(import('../pages/advertise/registration.vue' /* webpackChunkName: "pages/advertise/registration" */))
const _0e71fe8b = () => interopDefault(import('../pages/calendar/registration.vue' /* webpackChunkName: "pages/calendar/registration" */))
const _0fb54deb = () => interopDefault(import('../pages/customer/registration.vue' /* webpackChunkName: "pages/customer/registration" */))
const _5e87af0c = () => interopDefault(import('../pages/goals/analysis.vue' /* webpackChunkName: "pages/goals/analysis" */))
const _1b8a61bc = () => interopDefault(import('../pages/goals/setting.vue' /* webpackChunkName: "pages/goals/setting" */))
const _57f1ae56 = () => interopDefault(import('../pages/line/tracking/index.vue' /* webpackChunkName: "pages/line/tracking/index" */))
const _3284a257 = () => interopDefault(import('../pages/maisoku/export.vue' /* webpackChunkName: "pages/maisoku/export" */))
const _48799d46 = () => interopDefault(import('../pages/maisoku/template.vue' /* webpackChunkName: "pages/maisoku/template" */))
const _1fe4abe8 = () => interopDefault(import('../pages/response/registration.vue' /* webpackChunkName: "pages/response/registration" */))
const _2194d62a = () => interopDefault(import('../pages/sale/output.vue' /* webpackChunkName: "pages/sale/output" */))
const _cf087a50 = () => interopDefault(import('../pages/setting/announcement/index.vue' /* webpackChunkName: "pages/setting/announcement/index" */))
const _6d6da794 = () => interopDefault(import('../pages/setting/import/index.vue' /* webpackChunkName: "pages/setting/import/index" */))
const _75332d72 = () => interopDefault(import('../pages/setting/mail-template.vue' /* webpackChunkName: "pages/setting/mail-template" */))
const _0e4c23a9 = () => interopDefault(import('../pages/setting/matching-mail.vue' /* webpackChunkName: "pages/setting/matching-mail" */))
const _4a40d778 = () => interopDefault(import('../pages/setting/shop.vue' /* webpackChunkName: "pages/setting/shop" */))
const _3ab630f6 = () => interopDefault(import('../pages/setting/staff/index.vue' /* webpackChunkName: "pages/setting/staff/index" */))
const _6e66a9bd = () => interopDefault(import('../pages/setting/step-mail/index.vue' /* webpackChunkName: "pages/setting/step-mail/index" */))
const _d672c382 = () => interopDefault(import('../pages/setting/tag/index.vue' /* webpackChunkName: "pages/setting/tag/index" */))
const _75817c45 = () => interopDefault(import('../pages/shop/document-template/index.vue' /* webpackChunkName: "pages/shop/document-template/index" */))
const _977741c0 = () => interopDefault(import('../pages/shop/message/index.vue' /* webpackChunkName: "pages/shop/message/index" */))
const _7e54c4de = () => interopDefault(import('../pages/message/line/edit.vue' /* webpackChunkName: "pages/message/line/edit" */))
const _0d0a4320 = () => interopDefault(import('../pages/message/line/log.vue' /* webpackChunkName: "pages/message/line/log" */))
const _746ddcd0 = () => interopDefault(import('../pages/message/line/registration/index.vue' /* webpackChunkName: "pages/message/line/registration/index" */))
const _b64b3860 = () => interopDefault(import('../pages/message/line/select.vue' /* webpackChunkName: "pages/message/line/select" */))
const _6932375c = () => interopDefault(import('../pages/message/line/send.vue' /* webpackChunkName: "pages/message/line/send" */))
const _93f3b43a = () => interopDefault(import('../pages/message/mail/log.vue' /* webpackChunkName: "pages/message/mail/log" */))
const _1bf2dcaa = () => interopDefault(import('../pages/message/mail/registration.vue' /* webpackChunkName: "pages/message/mail/registration" */))
const _7d13e62d = () => interopDefault(import('../pages/message/mail/select.vue' /* webpackChunkName: "pages/message/mail/select" */))
const _409aa60e = () => interopDefault(import('../pages/message/mail/send.vue' /* webpackChunkName: "pages/message/mail/send" */))
const _1bf43ea3 = () => interopDefault(import('../pages/setting/announcement/registration.vue' /* webpackChunkName: "pages/setting/announcement/registration" */))
const _6f01463d = () => interopDefault(import('../pages/setting/import/Detail.vue' /* webpackChunkName: "pages/setting/import/Detail" */))
const _5a9d2f85 = () => interopDefault(import('../pages/setting/import/registration.vue' /* webpackChunkName: "pages/setting/import/registration" */))
const _4d7d9a8f = () => interopDefault(import('../pages/setting/real-estate-agent/property-range.vue' /* webpackChunkName: "pages/setting/real-estate-agent/property-range" */))
const _c1b42554 = () => interopDefault(import('../pages/setting/staff/registration.vue' /* webpackChunkName: "pages/setting/staff/registration" */))
const _34f087c4 = () => interopDefault(import('../pages/setting/step-mail/registration.vue' /* webpackChunkName: "pages/setting/step-mail/registration" */))
const _989c1bfe = () => interopDefault(import('../pages/message/line/registration/success.vue' /* webpackChunkName: "pages/message/line/registration/success" */))
const _eb585d1a = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _4d2dd2a6 = () => interopDefault(import('../pages/message/mail/edit/_id.vue' /* webpackChunkName: "pages/message/mail/edit/_id" */))
const _451526ea = () => interopDefault(import('../pages/agreement/log/_id.vue' /* webpackChunkName: "pages/agreement/log/_id" */))
const _83aec110 = () => interopDefault(import('../pages/agreement/registration/_id.vue' /* webpackChunkName: "pages/agreement/registration/_id" */))
const _1e950c67 = () => interopDefault(import('../pages/customer/edit/_id.vue' /* webpackChunkName: "pages/customer/edit/_id" */))
const _9f551d44 = () => interopDefault(import('../pages/media/registration/_id.vue' /* webpackChunkName: "pages/media/registration/_id" */))
const _3b5b20ee = () => interopDefault(import('../pages/project/registration/_id.vue' /* webpackChunkName: "pages/project/registration/_id" */))
const _7f81d726 = () => interopDefault(import('../pages/response/add/_id.vue' /* webpackChunkName: "pages/response/add/_id" */))
const _ed66c980 = () => interopDefault(import('../pages/setting/announcement/_id.vue' /* webpackChunkName: "pages/setting/announcement/_id" */))
const _323df1a6 = () => interopDefault(import('../pages/setting/staff/_id.vue' /* webpackChunkName: "pages/setting/staff/_id" */))
const _4e1df765 = () => interopDefault(import('../pages/setting/step-mail/_id.vue' /* webpackChunkName: "pages/setting/step-mail/_id" */))
const _6d9fa988 = () => interopDefault(import('../pages/shop/message/_id.vue' /* webpackChunkName: "pages/shop/message/_id" */))
const _4aebc78a = () => interopDefault(import('../pages/achievement/_id.vue' /* webpackChunkName: "pages/achievement/_id" */))
const _12819b54 = () => interopDefault(import('../pages/agreement/_id.vue' /* webpackChunkName: "pages/agreement/_id" */))
const _6235ca6c = () => interopDefault(import('../pages/client-history/_id.vue' /* webpackChunkName: "pages/client-history/_id" */))
const _7d67baf8 = () => interopDefault(import('../pages/customer/_id.vue' /* webpackChunkName: "pages/customer/_id" */))
const _36e542b0 = () => interopDefault(import('../pages/media/_id.vue' /* webpackChunkName: "pages/media/_id" */))
const _6420cab6 = () => interopDefault(import('../pages/project/_id.vue' /* webpackChunkName: "pages/project/_id" */))
const _6bef58a9 = () => interopDefault(import('../pages/property/_property.vue' /* webpackChunkName: "pages/property/_property" */))
const _d3dbc986 = () => interopDefault(import('../pages/property/_property/contact/index.vue' /* webpackChunkName: "pages/property/_property/contact/index" */))
const _5d60496b = () => interopDefault(import('../pages/property/_property/contact/confirm.vue' /* webpackChunkName: "pages/property/_property/contact/confirm" */))
const _37e89eed = () => interopDefault(import('../pages/property/_property/contact/send.vue' /* webpackChunkName: "pages/property/_property/contact/send" */))
const _72bf874a = () => interopDefault(import('../pages/response/_id.vue' /* webpackChunkName: "pages/response/_id" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/achievement",
    component: _df461dda,
    name: "achievement"
  }, {
    path: "/advertise",
    component: _4ce9824b,
    name: "advertise"
  }, {
    path: "/agreement",
    component: _73a4ec6e,
    name: "agreement"
  }, {
    path: "/calendar",
    component: _5a1ed020,
    name: "calendar"
  }, {
    path: "/customer",
    component: _1b6456e0,
    name: "customer"
  }, {
    path: "/details",
    component: _3ee104e6,
    name: "details"
  }, {
    path: "/goals",
    component: _84a3c1b8,
    name: "goals"
  }, {
    path: "/maisoku",
    component: _4ce6deff,
    name: "maisoku"
  }, {
    path: "/media",
    component: _42884e48,
    name: "media"
  }, {
    path: "/privacy",
    component: _e5bc3a2e,
    name: "privacy"
  }, {
    path: "/project",
    component: _405c7cfd,
    name: "project"
  }, {
    path: "/response",
    component: _6128ed9a,
    name: "response"
  }, {
    path: "/sale",
    component: _15668939,
    name: "sale"
  }, {
    path: "/achievement/output",
    component: _056b6990,
    name: "achievement-output"
  }, {
    path: "/achievement/registration",
    component: _1be8a808,
    name: "achievement-registration"
  }, {
    path: "/advertise/analysis",
    component: _3e98c01a,
    name: "advertise-analysis"
  }, {
    path: "/advertise/management",
    component: _4d8a93cc,
    name: "advertise-management"
  }, {
    path: "/advertise/registration",
    component: _a4ee7060,
    name: "advertise-registration"
  }, {
    path: "/calendar/registration",
    component: _0e71fe8b,
    name: "calendar-registration"
  }, {
    path: "/customer/registration",
    component: _0fb54deb,
    name: "customer-registration"
  }, {
    path: "/goals/analysis",
    component: _5e87af0c,
    name: "goals-analysis"
  }, {
    path: "/goals/setting",
    component: _1b8a61bc,
    name: "goals-setting"
  }, {
    path: "/line/tracking",
    component: _57f1ae56,
    name: "line-tracking"
  }, {
    path: "/maisoku/export",
    component: _3284a257,
    name: "maisoku-export"
  }, {
    path: "/maisoku/template",
    component: _48799d46,
    name: "maisoku-template"
  }, {
    path: "/response/registration",
    component: _1fe4abe8,
    name: "response-registration"
  }, {
    path: "/sale/output",
    component: _2194d62a,
    name: "sale-output"
  }, {
    path: "/setting/announcement",
    component: _cf087a50,
    name: "setting-announcement"
  }, {
    path: "/setting/import",
    component: _6d6da794,
    name: "setting-import"
  }, {
    path: "/setting/mail-template",
    component: _75332d72,
    name: "setting-mail-template"
  }, {
    path: "/setting/matching-mail",
    component: _0e4c23a9,
    name: "setting-matching-mail"
  }, {
    path: "/setting/shop",
    component: _4a40d778,
    name: "setting-shop"
  }, {
    path: "/setting/staff",
    component: _3ab630f6,
    name: "setting-staff"
  }, {
    path: "/setting/step-mail",
    component: _6e66a9bd,
    name: "setting-step-mail"
  }, {
    path: "/setting/tag",
    component: _d672c382,
    name: "setting-tag"
  }, {
    path: "/shop/document-template",
    component: _75817c45,
    name: "shop-document-template"
  }, {
    path: "/shop/message",
    component: _977741c0,
    name: "shop-message"
  }, {
    path: "/message/line/edit",
    component: _7e54c4de,
    name: "message-line-edit"
  }, {
    path: "/message/line/log",
    component: _0d0a4320,
    name: "message-line-log"
  }, {
    path: "/message/line/registration",
    component: _746ddcd0,
    name: "message-line-registration"
  }, {
    path: "/message/line/select",
    component: _b64b3860,
    name: "message-line-select"
  }, {
    path: "/message/line/send",
    component: _6932375c,
    name: "message-line-send"
  }, {
    path: "/message/mail/log",
    component: _93f3b43a,
    name: "message-mail-log"
  }, {
    path: "/message/mail/registration",
    component: _1bf2dcaa,
    name: "message-mail-registration"
  }, {
    path: "/message/mail/select",
    component: _7d13e62d,
    name: "message-mail-select"
  }, {
    path: "/message/mail/send",
    component: _409aa60e,
    name: "message-mail-send"
  }, {
    path: "/setting/announcement/registration",
    component: _1bf43ea3,
    name: "setting-announcement-registration"
  }, {
    path: "/setting/import/Detail",
    component: _6f01463d,
    name: "setting-import-Detail"
  }, {
    path: "/setting/import/registration",
    component: _5a9d2f85,
    name: "setting-import-registration"
  }, {
    path: "/setting/real-estate-agent/property-range",
    component: _4d7d9a8f,
    name: "setting-real-estate-agent-property-range"
  }, {
    path: "/setting/staff/registration",
    component: _c1b42554,
    name: "setting-staff-registration"
  }, {
    path: "/setting/step-mail/registration",
    component: _34f087c4,
    name: "setting-step-mail-registration"
  }, {
    path: "/message/line/registration/success",
    component: _989c1bfe,
    name: "message-line-registration-success"
  }, {
    path: "/",
    component: _eb585d1a,
    name: "index"
  }, {
    path: "/message/mail/edit/:id?",
    component: _4d2dd2a6,
    name: "message-mail-edit-id"
  }, {
    path: "/agreement/log/:id?",
    component: _451526ea,
    name: "agreement-log-id"
  }, {
    path: "/agreement/registration/:id?",
    component: _83aec110,
    name: "agreement-registration-id"
  }, {
    path: "/customer/edit/:id?",
    component: _1e950c67,
    name: "customer-edit-id"
  }, {
    path: "/media/registration/:id?",
    component: _9f551d44,
    name: "media-registration-id"
  }, {
    path: "/project/registration/:id?",
    component: _3b5b20ee,
    name: "project-registration-id"
  }, {
    path: "/response/add/:id?",
    component: _7f81d726,
    name: "response-add-id"
  }, {
    path: "/setting/announcement/:id",
    component: _ed66c980,
    name: "setting-announcement-id"
  }, {
    path: "/setting/staff/:id",
    component: _323df1a6,
    name: "setting-staff-id"
  }, {
    path: "/setting/step-mail/:id?",
    component: _4e1df765,
    name: "setting-step-mail-id"
  }, {
    path: "/shop/message/:id",
    component: _6d9fa988,
    name: "shop-message-id"
  }, {
    path: "/achievement/:id",
    component: _4aebc78a,
    name: "achievement-id"
  }, {
    path: "/agreement/:id",
    component: _12819b54,
    name: "agreement-id"
  }, {
    path: "/client-history/:id?",
    component: _6235ca6c,
    name: "client-history-id"
  }, {
    path: "/customer/:id",
    component: _7d67baf8,
    name: "customer-id"
  }, {
    path: "/media/:id",
    component: _36e542b0,
    name: "media-id"
  }, {
    path: "/project/:id",
    component: _6420cab6,
    name: "project-id"
  }, {
    path: "/property/:property?",
    component: _6bef58a9,
    name: "property-property",
    children: [{
      path: "contact",
      component: _d3dbc986,
      name: "property-property-contact"
    }, {
      path: "contact/confirm",
      component: _5d60496b,
      name: "property-property-contact-confirm"
    }, {
      path: "contact/send",
      component: _37e89eed,
      name: "property-property-contact-send"
    }]
  }, {
    path: "/response/:id",
    component: _72bf874a,
    name: "response-id"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
